import React from 'react';
import { ArrowUpRightIcon, FacebookIcon, InstagramIcon, MailIcon, MapPinIcon, MountainIcon, YoutubeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const exploreLinks = [['Manaslu Circuit Trek', '/routes/manaslu-circuit'], ['Meet Our Guides', '/guides'], ['Attractions', '/attractions'], ['Plan Your Trek', '/plan-your-trek']] as const;
const socialLinks = [{
  label: 'Follow Manaslu Trekking on Instagram',
  href: 'https://www.instagram.com',
  icon: InstagramIcon
}, {
  label: 'Follow Manaslu Trekking on Facebook',
  href: 'https://www.facebook.com',
  icon: FacebookIcon
}, {
  label: 'Watch Manaslu Trekking on YouTube',
  href: 'https://www.youtube.com',
  icon: YoutubeIcon
}];
export function Footer() {
  return <footer className="bg-[#1d3029] text-[#f7f4ed]" data-id="element-68" data-mp="29yxcxcohlklt">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 sm:py-20" data-id="element-69" data-mp="2a19qzer4jatl">
        <div className="grid gap-12 lg:grid-cols-[1.15fr_0.8fr_1fr]" data-id="element-70" data-mp="2ezuupo5l4cms">
          <div data-id="element-71" data-mp="3l8qvw2zluhqx">
            <Link to="/" aria-label="Manaslu Trekking home" className="inline-flex items-center gap-3 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#d9c78d]" data-id="element-72" data-mp="3labq1ri0byo9">
              <span className="inline-flex h-11 w-11 items-center justify-center border border-[#d9c78d]/70 text-[#d9c78d]" data-id="element-73" data-mp="3v5n5kc18p9x2">
                <MountainIcon className="h-6 w-6" aria-hidden="true" data-id="element-74" data-mp="830grbvt3sxb" />
              </span>
              <span className="font-serif text-3xl tracking-[0.04em] sm:text-4xl" data-id="element-75" data-mp="33xd9vvh5urg">
                Manaslu Trekking
              </span>
            </Link>
            <p className="mt-6 max-w-xs text-sm leading-7 text-[#cbd2ca]" data-id="element-76" data-mp="hrihjt43600y">
              Locally led Himalayan journeys, shaped with care for the mountains
              and the communities that make them home.
            </p>
            <a href="mailto:hello@manaslutrekking.com" className="mt-6 inline-flex items-center gap-2 text-sm text-[#f7f4ed] hover:text-[#d9c78d] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#d9c78d]" data-id="element-77" data-mp="qrfba95c1p2v">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="yv92royexstn" />
              hello@manaslutrekking.com
            </a>
          </div>
          <FooterLinks title="Explore" links={exploreLinks} data-id="element-79" data-mp="13r7mgz8sqmnq" />
          <div data-id="element-80" data-mp="18l2ecpyk27xw">
            <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#d9c78d]" data-id="element-81" data-mp="18lk7vetu2824">
              Begin your journey
            </h2>
            <p className="mt-5 text-sm leading-7 text-[#cbd2ca]" data-id="element-82" data-mp="1hkp42ehx9pb4">
              Tell us how you want to travel, and we’ll help shape the right
              Manaslu experience.
            </p>
            <Link to="/plan-your-trek" className="mt-6 inline-flex items-center gap-2 border-b border-[#d9c78d] pb-2 text-xs font-semibold uppercase tracking-[0.15em] text-[#f7f4ed] hover:text-[#d9c78d] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#d9c78d]" data-id="element-83" data-mp="1mhxmmg6zfvcw">
              Plan your trek{' '}
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-84" data-mp="2afx28yxda75g" />
            </Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-5 border-t border-[#4b5e54] pt-6 text-xs text-[#aab7ad] sm:flex-row sm:items-center sm:justify-between" data-id="element-85" data-mp="25n3x49xzkwsu">
          <p data-id="element-86" data-mp="1wo8oysbdtcmw">
            © {new Date().getFullYear()} Manaslu Trekking. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-5" data-id="element-87" data-mp="2te9eitjkrx59">
            <span className="inline-flex items-center gap-1" data-id="element-88" data-mp="2tbn32itkcxhr">
              <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-89" data-mp="2pcw6qdwx9jvp" />
              Kathmandu, Nepal
            </span>
            <nav aria-label="Social media links" className="flex items-center gap-2" data-id="element-90" data-mp="2kfe4t7hbo4x7">
              {socialLinks.map(({
              label,
              href,
              icon: Icon
            }) => <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label} className="inline-flex h-8 w-8 items-center justify-center border border-[#4b5e54] text-[#f7f4ed] transition-colors hover:border-[#d9c78d] hover:text-[#d9c78d] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#d9c78d]" data-id="element-91" data-mp="18w1njeqsufgm">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-92" data-mp="2ntcqv1j3e0r8" />
                </a>)}
            </nav>
          </div>
        </div>
      </div>
    </footer>;
}
function FooterLinks({
  title,
  links
}: {
  title: string;
  links: readonly (readonly [string, string])[];
}) {
  return <div data-id="element-93" data-mp="31mc1oq7xj6sg">
      <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#d9c78d]" data-id="element-94" data-mp="31khjvkryfusl">
        {title}
      </h2>
      <ul className="mt-5 space-y-3" data-id="element-95" data-mp="36j2hrdjqi2dv">
        {links.map(([label, to]) => <li key={to} data-id="element-96" data-mp="1q5cc42cyv624">
            <Link to={to} className="text-sm text-[#cbd2ca] transition-colors hover:text-[#f7f4ed] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#d9c78d]" data-id="element-97" data-mp="1q4swwtepavrs">
              {label}
            </Link>
          </li>)}
      </ul>
    </div>;
}